import { render } from "./IncludeSections.vue?vue&type=template&id=3f5db97a"
import script from "./IncludeSections.vue?vue&type=script&lang=js"
export * from "./IncludeSections.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__